module.exports = __webpack_public_path__ + "img/bczzsk.944bc1c1.png";